import { Box, Grid, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react";
import { TextField, Button } from '@roc/ui';
import { useState } from "react";
import { DraftLoan } from "@roc/feature-types";
import { useStore } from "@roc/client-portal-shared/hooks";

const useStyles = makeStyles((theme: Theme) => ({
  dialogStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  buttonStyle: {
    marginRight: '10px',
    height: '40px'
  },
  buttonStyleNoMargin: {
    height: '40px'
  },
  buttonContainer: {
    padding: '3px'
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(2)
  }
}));

interface rejectRequestFormProps {
  onClose: () => void;
  selectedCadence: any;
}

export const CadencePauseForm = observer(
  ({ onClose, selectedCadence }: rejectRequestFormProps) => {
    const classes = useStyles();
    const { cadenceStore } = useStore();
    const [reason, setReason] = useState('');

    const handleChange = (event) => {
      setReason(event.target.value)
    };

    const onConfirm = () => {
      cadenceStore.pauseCadence(selectedCadence, reason)
      onClose()
    }

    return (
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <TextField
            testId="pauseReason"
            variant="outlined"
            standaloneLabel
            label="Please write down the reason for the pause"
            multiline
            onChange={handleChange}
            minRows={2}
            required={true}
            fullWidth
          />
        </Grid>
        <Grid item container className={classes.buttonContainer} justifyContent="flex-end">
          <Box>
            <Button
              className={classes.buttonStyle}
              size='small'
              variant="contained"
              type="submit"
              onClick={onClose}
              color='primary'
              testId="cancelButton"
            >
              Cancel
            </Button>
            <Button
              className={classes.buttonStyleNoMargin}
              size='small'
              variant="contained"
              type="submit"
              onClick={onConfirm}
              color='primary'
              testId="requestingButton"
            >
              Pause
            </Button>
          </Box>
        </Grid>
      </Grid>
    );
  }
)